export * from './N20MainMenu';
export { default } from './N20MainMenu';
